import { createContext } from 'react'

import type { PpzAuthorizationPagedQuery } from '@/dtos'
import type { IPaginationContext } from 'BrokerTsLib/src/interfaces/Pagination/Pagination'

export const ppzAuthorizationListContext = createContext<IPaginationContext<PpzAuthorizationPagedQuery>>({} as IPaginationContext<PpzAuthorizationPagedQuery>)
